export default __webpack_public_path__ + "static/media/marketing-shape.b13d8778.png";